// Shared alert storage + browser notification helpers.
const KEY = "ym_alerts";
const EVT = "ym_alerts_changed";

export function getAlerts() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}

export function saveAlerts(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVT));
}

export function addAlert(alert) {
  const list = getAlerts();
  list.unshift(alert);
  saveAlerts(list);
}

export function removeAlert(id) {
  saveAlerts(getAlerts().filter((a) => a.id !== id));
}

export function markTriggered(id) {
  saveAlerts(getAlerts().map((a) => (a.id === id ? { ...a, triggered: true } : a)));
}

export function onAlertsChanged(cb) {
  window.addEventListener(EVT, cb);
  window.addEventListener("storage", cb);
  return () => {
    window.removeEventListener(EVT, cb);
    window.removeEventListener("storage", cb);
  };
}

export function notifyPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  return Notification.permission; // 'granted' | 'denied' | 'default'
}

export async function requestNotifyPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  try { return await Notification.requestPermission(); } catch { return "denied"; }
}

export function fireBrowserNotification(title, body) {
  try {
    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      const n = new Notification(title, { body, icon: "/favicon.ico", tag: "ym-alert" });
      setTimeout(() => { try { n.close(); } catch (_) {} }, 8000);
    }
  } catch (_) { /* ignore */ }
}
